module.exports = __webpack_public_path__ + "static/media/lock-mailer.d7c3b32c.ai";